export const GOAL_STATUS_OPTIONS = [
  { value: "success", label: "Approved" },
  { value: "verification_pending", label: "Pending" },
  { value: "failed", label: "Rejected" },
];

export const GOAL_STATUS_FILTER_OPTIONS = [
  { value: "", label: "All statuses" },
  ...GOAL_STATUS_OPTIONS,
];

export function getGoalStatusLabel(status) {
  const match = GOAL_STATUS_OPTIONS.find((opt) => opt.value === status);
  return match?.label || "Pending";
}

export function getGoalStatusColor(status) {
  switch (status) {
    case "success":
      return { bg: "#e8f5e9", color: "#2e7d32" };
    case "failed":
      return { bg: "#ffebee", color: "#c62828" };
    default:
      return { bg: "#fff8e1", color: "#f57c00" };
  }
}
